import React, {ReactElement} from 'react';
import {NxTableActionProps} from './NxTableTypes';

export class NxTableAction<RowData> extends React.Component<NxTableActionProps<RowData> & {
  action: {
    action: React.ComponentType<Omit<NxTableActionProps<RowData>, 'action'>>,
  }
}> {
  render(): ReactElement | null {
    const {action, ...rest} = this.props;
    return <action.action {...rest} />;
  }
}

export default NxTableAction;